<template>
  <div>
    <Banner />
    <!-- <ul
      id="main"
      class="navbar-nav ml-auto main-menu list-unstyled"
      style="background-color: #f78500"
    >
      <li @click="$router.push('/books')" class="parent nav-item">
        <router-link class="nav-link" @click="$router.push('/books')">
          {{ $t("Books") }}
        </router-link>
      </li>
    </ul>

    <div class="mt-10" style="background-color: #f78500">
      <div class="TopDestination">
        <vs-row class="mt-5" vs-w="12" vs-align="center" vs-justify="center">
          <vs-col vs-w="4" vs-sm="12">
            <CustomButton
              Type="border"
              @click="$router.push('/books')"
              Color="rgb(255, 255, 255)"
              :title="$t('Books')"
            />
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" vs-sm="12">
            <custom-button
              id="hoverButton"
              @click="$router.push('/audios')"
              style="width: 100%"
              class="m-2"
              Type="border"
              Color="rgb(255, 255, 255)"
              :title="$t('Audios')"
            />
          </vs-col>
          <vs-col vs-type="flex" vs-w="4" vs-sm="12">
            <custom-button
              id="hoverButton"
              @click="$router.push('/videos')"
              style="width: 100%"
              Type="border"
              Color="rgb(255, 255, 255)"
              :title="$t('Videos')"
            />
          </vs-col>
        </vs-row>
      </div>
    </div> -->
    <!-- SinksarAndKatamars -->
    <!-- <div class="container">
      <div class="section-title-wrapper">
        <div class="row">
          <div class="col-sm-12 col-md-6 mx-auto text-center">
             <h2>RecentlyViewed</h2> 
          </div>
        </div>
      </div>
      <SinksarAndKatamars />
    </div> -->
    <!-- RecentView -->
    <div
      class="service section-gap"
      v-if="$store.state.HomeList.LatestActivity.length > 0"
    >
      <div class="container">
        <div class="section-title-wrapper">
          <div class="row">
            <div class="col-sm-12 col-md-6 mx-auto text-center">
              <h2>{{ $t("RecentlyViewed") }}</h2>
            </div>
          </div>
        </div>
        <RecentView />
      </div>
    </div>
    <!-- quick bar -->
    <div class="service m-4">
      <div class="container" style="background-color: #f78500">
        <div class="col-sm-12 col-md-12 col-lg-12">
          <div class="row">
            <div class="col col-sm-2 col-md-2 col-lg-3"></div>
            <div class="col col-sm-4 col-md-4 col-lg-2">
              <button
                class="btn btn-primary font-weight-bold"
                style="width: 100%"
                @click="GotoBooks"
              >
                <h3>
                  <p class="font-weight-bold mt-3" style="color: #f2f2f2">
                    {{ $t("Books") }}
                  </p>
                </h3>
              </button>
            </div>
            <div class="col col-sm-4 col-md-4 col-lg-2">
              <button
                class="btn btn-primary font-weight-bold"
                style="width: 100%"
                @click="GotoAudios"
              >
                <h3>
                  <p class="font-weight-bold mt-3" style="color: #f2f2f2">
                    {{ $t("Audios") }}
                  </p>
                </h3>
              </button>
            </div>
            <div class="col col-sm-4 col-md-4 col-lg-2">
              <button
                class="btn btn-primary font-weight-bold"
                style="width: 100%"
                @click="GotoVideos"
              >
                <h3>
                  <p class="font-weight-bold mt-3" style="color: #f2f2f2">
                    {{ $t("Videos") }}
                  </p>
                </h3>
              </button>
            </div>
            <div class="col col-sm-2 col-md-2 col-lg-3"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- book -->
    <div class="service m-4" >
      <div class="container">
        <div class="row mb-4" style="background: #263238;">
          <div class="col-sm-12 col-md-6 text-center mx-auto mb-6">
            <h2 style="color: #f2f2f2">{{ $t("NewBooks") }}</h2>
          </div>
        </div>
        <NewBooks />
      </div>
    </div>
    <!-- audio -->
    <div class="service m-4">
      <div class="container">
        <div class="row"  style="background: #263238;">
          <div class="col-sm-12 col-md-6 mx-auto text-center">
            <h2 style="color: #f2f2f2">{{ $t("NewAudioArrivals") }}</h2>
          </div>
        </div>

        <NewAudio />
      </div>
    </div>
    <!-- video -->
    <div class="service m-4">
      <div class="container">
        <div class="row"  style="background: #263238;">
          <div class="col-sm-12 col-md-6 mx-auto text-center">
            <h2 style="color: #f2f2f2">{{ $t("NewVideoArrivals") }}</h2>
          </div>
        </div>

        <NewVideo />
      </div>
    </div>
  </div>
</template>

<script>
import moduleHome from "@/store/home/moduleHome.js";

// @ is an alias to /src
// import RecentView from "@/views/HomePages/RecentView.vue";
// import Subscriber from "Components/Sections/Subscriber";
import Banner from "@/components/Banner/Banner.vue";
import RecentView from "@/views/HomePages/RecentView.vue";
import NewAudio from "@/views/HomePages/NewAudio.vue";
import NewVideo from "@/views/HomePages/NewVideo.vue";

import NewBooks from "@/views/HomePages/NewBooks.vue";
import SinksarAndKatamars from "@/views/HomePages/SinksarAndKatamars.vue";

import CustomButton from "@/components/CustomButton.vue";


// import ServiceSection from "Components/Sections/ServiceSection";
// import TestimonialSlider from "Components/Sections/TestimonialSlider.vue";
// import PricingV2 from "Components/Sections/PricingV2.vue";
// import TeamGrid from "Components/Sections/TeamGrid.vue";
// import MobileFeature from "Components/Sections/MobileFeature.vue";
// import PortfolioGrid from "Components/Sections/PortfolioGrid.vue";
// import LatestBlog from "Components/Sections/LatestBlog.vue";
// import ContactInfo from "Components/Sections/ContactInfo.vue";
// import SendMessage from "Components/Sections/SendMessage.vue";
// import VideoSectionV1 from "Components/Sections/VideoSectionV1.vue";
// import videoContent from "Components/data/home.json";
export default {
  data() {
    return {
      // videoContent,
    };
  },
  components: {
    // Subscriber,
    Banner,
    RecentView,
    NewBooks,
    SinksarAndKatamars,
    NewAudio,
    NewVideo,
    CustomButton,
    
    // ServiceSection,
    // TestimonialSlider,
    // PricingV2,
    // TeamGrid,
    // MobileFeature,
    // PortfolioGrid,
    // LatestBlog,
    // ContactInfo,
    // SendMessage,
    // VideoSectionV1,
  },
  created() {
    debugger;
    if (!moduleHome.isRegistered) {
      this.$store.registerModule("HomeList", moduleHome);
      moduleHome.isRegistered = true;
    }

    this.$store
      .dispatch("HomeList/GetDailyInfo")

      .then(() => {})
      .catch(() => {});
  },
  methods: {
    GotoBooks() {
      this.$router.push({ name: "books" });
    },
    GotoAudios() {
      this.$router.push({ name: "audios" });
    },
    GotoVideos() {
      this.$router.push({ name: "videos" });
    },
  },
  computed: {},
};
</script>

<style lang="scss">
.PlayIcon {
  top: 45%;
  right: 30px;
  z-index: 500;
}
._cartBtn {
  left: 1.25rem;
}

._addtoFav {
  cursor: pointer;
}
.TopDestination {
  text-transform: uppercase;
  width: 100%;
  margin: auto;
  padding: 1vh;
}
</style>
